import _ from 'lodash';
import DepsService from 'services/dependencies';
import appHelpers from 'app/app-helpers';

const namespace = 'dictionaries';

export const SET_DICT_BY_NAME = `${namespace}_SET_DICT_BY_NAME`;
const DICT_REPORT_CATEGORY_KEY = 'report-category';
const CONTEXT = 'privilegeTemplates';

const PACK_STATUS = 'PACK_STATUS';

export const getUserTemplates = (userClass) => (dispatch, getState) => {
  const {
    session: { locale },
  } = getState();
  let url;
  switch (userClass) {
    case 'ADMIN':
      url = DepsService.rest.privileges.ADMIN.templates.url;
      break;
    case 'RETAILER_PRIMARY':
      url = DepsService.rest.privileges.RETAILER_PRIMARY.templates.url;
      break;
    case 'RETAILER_SECONDARY':
      url = DepsService.rest.privileges.RETAILER_SECONDARY.templates.url;
      break;
    case 'RETAILER_PROSPECTIVE':
      url = DepsService.rest.privileges.RETAILER_PROSPECTIVE.templates.url;
      break;
  }

  return DepsService.restSrv.list(CONTEXT, url).then((result) => {
    const items = result.map((item) => {
      item.displayName = _.capitalize(_.get(item, `translations[${locale}].name`));
      item.name = _.get(item, `translations[${locale}].name`);
      return item;
    });

    dispatch({
      type: SET_DICT_BY_NAME,
      payload: {
        name: 'userTemplates',
        items,
      },
    });
  });
};

export const getUserClasses = () => (dispatch, getState) => {
  const {
    dictionaries: { userClasses },
  } = getState();

  if (Object.keys(userClasses || {}).length) {
    return Promise.resolve(userClasses);
  }

  return DepsService.restSrv.list(undefined, DepsService.rest.dictionary.names.url, null, { name: 'user-class' }).then((result) => {
    const keys = Object.keys(result.values || {});
    const items = keys.reduce((prev, current) => {
      prev[current] = {
        id: current,
        label: result.values[current],
      };

      return prev;
    }, {});

    dispatch({
      type: SET_DICT_BY_NAME,
      payload: {
        name: 'userClasses',
        items,
      },
    });
    return items;
  });
};

export const getRetailerGroupUserClasses = () => (dispatch, getState) => {
  const {
    dictionaries: { retailerGroupUserClasses },
  } = getState();

  if (Object.keys(retailerGroupUserClasses || {}).length) {
    return Promise.resolve(retailerGroupUserClasses);
  }

  return DepsService.restSrv.list(undefined, DepsService.rest.dictionary.names.url, null, { name: 'user-class' }).then((result) => {
    const keys = Object.keys(result.values || {}).filter((key) => key !== 'ADMIN');
    const items = keys.reduce((prev, current) => {
      prev[current] = {
        id: current,
        label: result.values[current],
      };

      return prev;
    }, {});

    dispatch({
      type: SET_DICT_BY_NAME,
      payload: {
        name: 'retailerGroupUserClasses',
        items,
      },
    });
    return items;
  });
};

export const getJobSchedulingStatuses = () => (dispatch) =>
  DepsService.restSrv.list(undefined, DepsService.rest.dictionary.names.url, null, { name: 'batch-statuses' }).then((result) => {
    const keys = Object.keys(result.values || {});
    const items = keys.map((key) => ({
      id: key,
      label: result.values[key],
    }));

    dispatch({
      type: SET_DICT_BY_NAME,
      payload: {
        name: 'jobSchedulingStatuses',
        items,
      },
    });
  });

export const loadReportNames = (category) => (dispatch, getState) => {
  const {
    session: {
      locale,
      retailer: { retailerType },
    },
  } = getState();

  return DepsService.restSrv
    .list(undefined, DepsService.rest.reports.names.url, {
      locale: '*',
      retailerType,
      category,
    })
    .then((results) => {
      results.categoryList.map((category) => {
        category.fileTypeTranslationsDto = category.fileTypeTranslationsDto.reduce((reduced, current) => {
          reduced[current.locale] = current;
          return reduced;
        }, {});
      });

      results.categoryList = _.orderBy(results.categoryList, [`.fileTypeTranslationsDto[${locale}].fileDisplayNm`], ['asc']);
      dispatch({
        type: SET_DICT_BY_NAME,
        payload: {
          name: 'reportNames',
          items: results.categoryList,
        },
      });
    });
};

export const loadReportCategories = () => (dispatch) =>
  DepsService.restSrv
    .list(undefined, DepsService.rest.dictionary.names.url, { locale: '*' }, { name: DICT_REPORT_CATEGORY_KEY })
    .then((results) => {
      const items = Object.keys(results.values).map((key) => ({
        name: results.values[key],
        id: key,
      }));

      dispatch({
        type: SET_DICT_BY_NAME,
        payload: {
          name: 'reportCategories',
          items,
        },
      });
    });

export const loadReportExtensions = () => (dispatch) =>
  DepsService.restSrv.list(undefined, DepsService.rest.reports.extension.url).then((items) => {
    dispatch({
      type: SET_DICT_BY_NAME,
      payload: {
        name: 'reportExtensions',
        items,
      },
    });
  });

export const loadTransformationTypes = () => (dispatch) =>
  DepsService.restSrv.list(null, DepsService.rest.account.report.transformation.types.url).then((items) => {
    dispatch({
      type: SET_DICT_BY_NAME,
      payload: {
        name: 'transformationTypes',
        items,
      },
    });
  });

export const loadIpsStatus = () => (dispatch, getState) => {
  const {
    session: { locale },
  } = getState();
  return DepsService.restSrv
    .listCached(null, DepsService.session.rest.inventory.dictionaries.url, {
      locale: locale || '*',
      typeCategory: PACK_STATUS,
    })
    .then((data) => {
      const items = data.reduce((prev, current) => {
        prev[current.typeCode] = {
          displayText: current.typeDesc,
        };
        return prev;
      }, {});

      dispatch({
        type: SET_DICT_BY_NAME,
        payload: {
          name: 'ipsStatuses',
          items,
        },
      });
    });
};

export const loadRetailerGroupsCreateChannels = () => (dispatch) => {
  const { url } = DepsService.session.rest.navigator.typecodes;
  return DepsService.restSrv.listCached(null, url, { category: 'rs.reporting-group.create-channel' }).then((data) => {
    dispatch({
      type: SET_DICT_BY_NAME,
      payload: {
        name: 'retailerGroupsCreateChannels',
        items: appHelpers.extractDictionaryItem(data),
      },
    });
  });
};

export const loadRetailerGroupTypes = () => (dispatch) => {
  const { url } = DepsService.session.rest.navigator.typecodes;
  return DepsService.restSrv.listCached(null, url, { category: 'rs.reporting-group.group-type' }).then((data) => {
    dispatch({
      type: SET_DICT_BY_NAME,
      payload: {
        name: 'retailerGroupTypes',
        items: appHelpers.extractDictionaryItem(data),
      },
    });
  });
};

export const loadRetailerGroupSubTypes = () => (dispatch) => {
  const { url } = DepsService.session.rest.navigator.typecodes;
  return DepsService.restSrv.listCached(null, url, { category: 'rs.reporting-group.group-sub-type' }).then((data) => {
    dispatch({
      type: SET_DICT_BY_NAME,
      payload: {
        name: 'retailerGroupSubTypes',
        items: appHelpers.extractDictionaryItem(data),
      },
    });
  });
};

export const loadRetailerGroupStatuses = () => (dispatch) => {
  const { url } = DepsService.session.rest.navigator.typecodes;
  return DepsService.restSrv.listCached(null, url, { category: 'rs.reporting-group.status' }).then((data) => {
    dispatch({
      type: SET_DICT_BY_NAME,
      payload: {
        name: 'retailerGroupStatuses',
        items: appHelpers.extractDictionaryItem(data),
      },
    });
  });
};



// WEBPACK FOOTER //
// ./src/modules/app/actions/dictionaries.actions.js